import { InjectionToken, WritableSignal } from '@angular/core';
import { Company } from '@type/company';

export const CURRENT_COMPANY_TOKEN = new InjectionToken<WritableSignal<Company>>('CURRENT_COMPANY_TOKEN');
